import { render } from "./PageMascotVisual.vue?vue&type=template&id=b50b56b6"
import script from "./PageMascotVisual.vue?vue&type=script&lang=js"
export * from "./PageMascotVisual.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__